<script>
    import { showToast } from '../utils/Toast';
    import { accessToken } from '../stores/cachedStores';
    import userStore from '../stores/userStore';
    import { connectMetaMask, loginMetaMask } from '../controllers/APIController';
    import jwt_decode from "jwt-decode"
    import friendsStore from '../stores/friendsStore';
    import { navigate } from 'svelte-routing';
    import { onMount } from 'svelte';
    
    let loginButton;
    let accounts;
    let challenge;

    const onKeyPress = e => {
        if (e.charCode === 13) onLogin();
    };

    async function onLogin() 
    {
        loginButton.disabled = true;
        try {
            const res = await connectMetaMask();
            console.log("Connect success:" + JSON.stringify(res.accounts) + " | " + res.challenge);
            accounts = res.accounts;
            challenge = res.challenge;

            const loginRes = await loginMetaMask(challenge);
            console.log("Login Success: " + JSON.stringify(loginRes));
            
            accessToken.set(loginRes.access_token); //save & cache accessToken
            window.location.reload();  //reload app to access fetch user and friends data

        } catch (error) {
            showToast("Error: " + error.errorMessage, () => { 
                if (loginButton)
                    loginButton.disabled = false; 
            });
        }
    }
</script>

<ion-header>
    <ion-toolbar>
      <ion-title>Login</ion-title>
    </ion-toolbar>
  </ion-header>

<ion-content scroll-y="false">
  
    <div class="loginPanel">
        <p>Welcome back, please login to your account</p>
        <br>
        <div style="text-align: center; align-content: center; width: 200px;">
        <ion-button bind:this={loginButton} on:click={onLogin}>Log In with MetaMask</ion-button>
        </div>
    </div>
    <br>
</ion-content>

<style>
    .loginPanel {
        align-content: left;
        text-align: left;
        padding: 15px;
    }

    .field {
       max-width: 300px;
    }
</style>
